import React from "react";
import { uiNotification } from "../../../../../services/UINotificationService";
import { history } from "../../../../../history";
import { getPathParams } from "../utilities";
import { extractApiError } from "../../../../../utilities/api";
import { CLIENTS_ROUTES } from "../../../../../consts/routes";
import { usePatientDocumentUpdateMutation } from "../../../../../api/patientDocuments/usePatientDocumentUpdateMutation";
import { MESSAGES } from "../config";
import { not } from "../../../../../utilities/fp";

import { usePermission } from "../../../../../hooks/usePermission";
import { DOCUMENT_TYPES } from "../../../../../api/patientDocuments/usePatientDocumentsQuery";

export var withDocumentUpdate = (Component) => (props) => {
  var { patientId, documentId } = getPathParams();

  const { permitted: canManageMedicalHistory } = usePermission(
    "manage-medical-history",
  );

  var { mutateAsync, isLoading } = usePatientDocumentUpdateMutation({
    onSuccess: () => {
      uiNotification.success("Document updated successfully");
      history.push(CLIENTS_ROUTES.newDocuments(patientId));
    },
    onError: (res) => {
      var message = extractApiError(res);
      uiNotification.error(
        MESSAGES[message] ||
          "Unable to update document. Please try again later.",
      );
    },
  });

  var initiate = async (document) => {
    if (
      !canManageMedicalHistory &&
      document.doc_type === DOCUMENT_TYPES.medicalHistory
    ) {
      return uiNotification.error(
        "You do not have permission to manage medical history",
      );
    }

    if ([document.name, document.filename, document.doc_type].some(not)) {
      return uiNotification.error("Please fill all required fields");
    }

    await mutateAsync({
      patientId,
      documentId,
      name: document.name,
      filename: document.filename,
      doc_type: document.doc_type,
      expiration_date: document.expiration_date,
      description: document.description,
    });
  };

  return (
    <Component
      {...props}
      updateDocument={{
        initiate,
        isLoading,
      }}
    />
  );
};
